import React from 'react';
// // Core viewer
import { Viewer } from '@react-pdf-viewer/core';
import { Worker } from '@react-pdf-viewer/core';
// // Plugins
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
// import { scrollModePlugin } from '@react-pdf-viewer/scroll-mode';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '../../../../style/index.css';
import { Button } from '@material-ui/core';
import { sendMailQuestion } from '../../../../Utils/sendMail';

export const ViewQuestionPaperPdf2 = () => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const mailApproved = () => {
    sendMailQuestion();
  };
  return (
    <>
      <div
        style={{
          height: '500px',
          width: '48%',
          marginRight: '10px',
        }}
      >
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
          <Viewer
            fileUrl="/pdf/SPJAT_SAMPLE_PAPER_No_1.pdf"
            plugins={[defaultLayoutPluginInstance]}
          />
        </Worker>
        <div className="col-12">
          <Button
            variant="primary"
            className="col-btn"
            // component={Link}
            // className={classOfBtn}
            // to={`${routes.seatingPlan}/arrangement/${id}`}
            onClick={() => {
              mailApproved();
            }}
          >
            Approve
          </Button>
          <Button
            variant="primary"
            // component={Link}
            // className={classes.publishGenerate}
            // // to={`${routes.currentProgrammes}/${id}/details`}
          >
            Remind
          </Button>
        </div>
      </div>
    </>
  );
};
